var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.5688 29.2929-2.0688.6475-1.7875.5594h-9.3881l-1.8244-5.8287-6-19.17128 6-1.87812 6.4062-2.005 6.5938 21.0669z",
    fill: "#379a6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.183 26.9985.448 1.4315-5.726 1.7922-.4481-1.4316-1.4315.4481-6.5713-20.99572 1.4315-.448-.448-1.43157 5.7261-1.79212.448 1.4315 1.4315-.44806 6.5713 20.99567z",
    fill: "#44c086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 1.5h13v29h-13z",
    fill: "#3ba673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20 27v1.5h-6v-1.5h-1.5v-22h1.5v-1.5h6v1.5h1.5v22z",
    fill: "#44c086"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17 18.5c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5z",
    fill: "#3ba673"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m27.5001 18.5v12h-3.5c-1.326 0-2.5978-.5268-3.5355-1.4645-.9377-.9376-1.4645-2.2094-1.4645-3.5355h.01l-3.2437-4.8003c-.297-.4395-.4072-.979-.3064-1.4998.1008-.5207.4044-.9801.8439-1.2771.4395-.2969.979-.4071 1.4998-.3063.5207.1008.9801.4043 1.2771.8438l2.9193 4.0397h1.5v-12l3.7647 7.0588c.1545.2897.2353.6129.2353.9412z",
    fill: "#b9967a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment);
export default __webpack_public_path__ + "static/media/cash-payment.9070f1541f12749838b9d485d3ad0b3e.svg";
export { ForwardRef as ReactComponent };